import { Plus, Trash2 } from 'lucide-react'
import type { ExerciseEditorProps } from '@/types'

interface OptionListEditorProps {
  formData: ExerciseEditorProps['formData']
  setFormData: ExerciseEditorProps['setFormData']
  isViewMode?: boolean
  minOptions?: number
}

export default function OptionListEditor({
  formData,
  setFormData,
  isViewMode,
  minOptions = 2,
}: OptionListEditorProps) {
  const addOption = () => {
    setFormData(prev => ({ ...prev, options: [...prev.options, ''] }))
  }

  const removeOption = (index: number) => {
    setFormData(prev => ({ ...prev, options: prev.options.filter((_, i) => i !== index) }))
  }

  const updateOption = (index: number, value: string) => {
    setFormData(prev => ({
      ...prev,
      options: prev.options.map((o, i) => i === index ? value : o)
    }))
  }

  return (
    <>
      {/* Opciones */}
      <div>
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-gray-700">
            Opciones de Respuesta
          </span>
          {!isViewMode && (
            <button
              type="button"
              onClick={addOption}
              className="text-sm text-[#0055A4] hover:text-[#0055A4] flex items-center gap-1"
            >
              <Plus className="w-4 h-4" />
              Agregar
            </button>
          )}
        </div>
        <div className="space-y-2">
          {formData.options.map((option, index) => (
            <div key={index} className="flex items-center gap-2">
              <span className="text-sm font-medium text-gray-500 w-7 text-center">
                {String.fromCharCode(65 + index)}.
              </span>
              <input
                type="text"
                value={option}
                onChange={(e) => updateOption(index, e.target.value)}
                placeholder={`Opción ${String.fromCodePoint(65 + index)}`}
                className="flex-1 px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0055A4] focus:border-[#0055A4] disabled:bg-gray-100 disabled:cursor-not-allowed"
                disabled={isViewMode}
              />
              {formData.options.length > minOptions && !isViewMode && (
                <button
                  type="button"
                  onClick={() => removeOption(index)}
                  className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg"
                >
                  <Trash2 className="w-4 h-4" />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Respuesta correcta */}
      <div>
        <label htmlFor="correct-answer" className="block text-sm font-medium text-gray-700 mb-1">
          Respuesta Correcta
        </label>
        <select id="correct-answer" value={formData.correct_answer}
          onChange={(e) => setFormData(prev => ({ ...prev, correct_answer: e.target.value }))}
          className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-[#0055A4] focus:border-[#0055A4] disabled:bg-gray-100 disabled:cursor-not-allowed"
          required
          disabled={isViewMode}
        >
          <option value="">Seleccionar respuesta correcta...</option>
          {formData.options.map((option, index) => (
            option.trim() && (
              <option key={index} value={option}>
                {String.fromCodePoint(65 + index)}. {option}
              </option>
            )
          ))}
        </select>
      </div>
    </>
  )
}
